
export const PRELEVEMENT_ENTITES = ["Prod", "R&D", "Indus 4.0"];
export const DEFAULT_PRELEVEMENT_ENTITE = "Prod";
